import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import classnames from "../../utils/classnames.js";
import './Icon.css';/* empty css          */
const Icon = ({ name, className, size, style, sticker }) => {
  const resolvedStyle = useMemo(() => {
    if (typeof sticker === "undefined" && typeof size === "undefined") {
      return style;
    }
    const resolvedSize = typeof size === "number" ? `${size}px` : size || "inherit";
    if (typeof sticker === "undefined") {
      return {
        "--perxis-auto-icon-font-size": resolvedSize,
        ...style
      };
    }
    return {
      [`--perxis-auto-${sticker}-font-size-inner`]: `var(--perxis-auto-${sticker}-font-size, ${resolvedSize})`,
      "--perxis-auto-icon-font-size": `var(--perxis-auto-${sticker}-font-size-inner)`,
      ...style
    };
  }, [sticker, style, size]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: resolvedStyle,
      className: classnames(["perxis-auto-icon", `perxis-auto-icon-${name}`], [`pa-icon`, `pa-icon-${name}`, className])
    }
  );
};
export {
  Icon as default
};
//# sourceMappingURL=Icon.js.map
